import { render, staticRenderFns } from "./safetyEducation.vue?vue&type=template&id=eb610e04&scoped=true&"
import script from "./safetyEducation.vue?vue&type=script&lang=js&"
export * from "./safetyEducation.vue?vue&type=script&lang=js&"
import style0 from "./safetyEducation.vue?vue&type=style&index=0&id=eb610e04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb610e04",
  null
  
)

export default component.exports